import { Badge } from 'react-native-paper';
import { withUnistyles } from 'react-native-unistyles';

/**
 * Shared unread-count badge. Renders nothing at 0, caps display at 99+.
 * Uses the default react-native-paper Badge colors, matching existing badges
 * (ConversationsList, ReachTabBar, DrawerMenu).
 */
const NotificationBadge = ({ count, size = 18, style, testID }) => {
    const UniBadge = withUnistyles(Badge);

    if (!count || count <= 0) return null;
    return (
        <UniBadge size={size} style={style} testID={testID}>
            {count > 99 ? '99+' : count}
        </UniBadge>
    );
};

export default NotificationBadge;
